import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { useMineCompany } from "@/features/company/hooks/useMineCompany";
import { CalendarClock, SearchIcon } from "lucide-react";
import { useMaintenanceWorkflowSchedules } from "../../hooks/useMaintenanceWorkflowSchedules";
import { MaintenanceWorkflowSchedulesTransformer } from "../../services/maintenanceWorkflowSchedulesTransformer";
import ListHeader from "@/common/components/ListHeader";
import { maintenanceWorkflowSchedulesDefaultColumns } from "../../constants/workflowSchedulesColumns.constant";
import ListFilters from "@/common/components/ListFilters";
import { maintenanceWorkflowSchedulesKindOptions } from "../../constants/kind.constant";

const MaintenanceWorkflowSchedulesList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search);

  const { data: companyData } = useMineCompany();

  const {
    meta,
    data: workflowSchedules,
    isPending: workflowSchedulesIsPending,
    error: workflowSchedulesError = {} as any,
    refetch: refetchworkflowSchedules,
  } = useMaintenanceWorkflowSchedules({
    filters: {
      search: search,
      page: Number(filterParams.page) || 1,
      companyId: companyData?.id,
      kind: filterParams.kind?.value || ''
    },
    mapper: MaintenanceWorkflowSchedulesTransformer.tableTransformer(),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={workflowSchedulesError?.status}
      refetchFunction={refetchworkflowSchedules}
    >
      <div className="flex flex-col gap-6">
        <ListHeader
          title="Programação de Manutenção"
          Icon={<CalendarClock className="w-10 h-10" strokeWidth={1.5} />}
          createButtonText="Cadastrar programação"
          operationKlassToCheckPermission="Client::Maintenance::WorkflowSchedules::Create"
          disableCreateButton={workflowSchedulesIsPending || workflowSchedulesError?.status === 403}
        />
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar por ID ou Nome da programação de manutenção"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value, page: 1 }));
              }}
              value={filterParams.search}
            />

             <ListFilters
              filters={[
                {
                  className: 'min-w-40',
                  placeholder: 'Tipo',
                  options: [{ label: 'Todos', value: '' } , ...maintenanceWorkflowSchedulesKindOptions],
                  onChange: (kind) => setFilterParams((prev) => ({ ...prev, kind })),
                  value: filterParams.kind,
                },
              ]}
            />
          </div>

          <Table
            className="max-h-[calc(100vh-324px)]"
            columns={maintenanceWorkflowSchedulesDefaultColumns}
            isLoadingData={workflowSchedulesIsPending}
            page={filterParams.page || 1}
            rows={workflowSchedules}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowSchedulesList;
